var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M22 2.11C21.18 2.47 20.31 2.71 19.4 2.82C20.33 2.27 21.04 1.39 21.38 0.33C20.51 0.85 19.55 1.22 18.52 1.42C17.69 0.54 16.51 0 15.23 0C12.73 0 10.72 2.02 10.72 4.51C10.72 4.86 10.75 5.21 10.82 5.54C7.07 5.35 3.76 3.56 1.53 0.82C1.14 1.49 0.91 2.27 0.91 3.1C0.91 4.66 1.71 6.04 2.91 6.85C2.19 6.83 1.48 6.62 0.87 6.29C0.87 6.3 0.87 6.32 0.87 6.34C0.87 8.53 2.44 10.35 4.49 10.77C4.12 10.87 3.72 10.92 3.31 10.92C3.02 10.92 2.73 10.9 2.45 10.84C3.04 12.63 4.69 13.94 6.67 13.98C5.13 15.18 3.18 15.91 1.07 15.91C0.7 15.91 0.35 15.89 0 15.85C1.99 17.13 4.36 17.87 6.91 17.87C15.21 17.87 19.75 11 19.75 5.04C19.75 4.84 19.74 4.64 19.73 4.45C20.63 3.82 21.38 3.02 22 2.11Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.d59e50e4b6d49b7be260ca57b17fba81.svg";
export { ForwardRef as ReactComponent };